/**
 * カートページ：配達希望日ピッカー
 * 依存: Splice <cart-items> が発火する on:line-item:change イベント
 * 保存先: cart.attributes['delivery-date'] (YYYY/MM/DD, ネクストエンジン取込仕様準拠)
 */
(function () {
	if (window.customElements && customElements.get("custom-cart-delivery-date"))
		return;

	var NOTICE_TEXT =
		"カート内にお届けにお時間を頂戴する商品が含まれている為、配達希望日を選択いただけません。";

	function cartHasLeadTime(cart) {
		return cart.items.some(function (item) {
			return item && item.properties && item.properties["納期"];
		});
	}

	// グローバルリスナー: カート空時・納期あり商品の混在時に delivery-date 属性をクリアする。
	// (要素自体がカート再描画で DOM から消えるため、要素内では受け取れない)
	if (!window.__customCartDeliveryDateCleanupBound) {
		window.__customCartDeliveryDateCleanupBound = true;
		var clearOnCartChange = function (event) {
			var cart = event && event.detail && event.detail.cart;
			if (!cart || !Array.isArray(cart.items)) return;
			if (cart.item_count !== 0 && !cartHasLeadTime(cart)) return;
			if (!cart.attributes || !cart.attributes["delivery-date"]) return;
			fetch("/cart/update.js", {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Accept: "application/json",
				},
				body: JSON.stringify({ attributes: { "delivery-date": "" } }),
			}).catch(function (err) {
				console.error("[delivery-date] failed to clear cart attribute", err);
			});
		};
		document.addEventListener("on:line-item:change", clearOnCartChange);
		document.addEventListener("on:cart:add", clearOnCartChange);
	}

	function toSlash(dashValue) {
		if (!dashValue) return "";
		return String(dashValue).replace(/-/g, "/");
	}

	function toDash(slashValue) {
		if (!slashValue) return "";
		return String(slashValue).replace(/\//g, "-");
	}

	function pad(n) {
		return n < 10 ? "0" + n : String(n);
	}

	// iOS/Android はフォーカスだけでネイティブピッカーが開く
	function isCoarsePointer() {
		return (
			typeof window.matchMedia === "function" &&
			window.matchMedia("(pointer: coarse)").matches
		);
	}

	function laterDate(a, b) {
		if (!a) return b || "";
		if (!b) return a;
		return a > b ? a : b;
	}

	function computeMinDate() {
		var d = new Date();
		d.setHours(0, 0, 0, 0);
		d.setDate(d.getDate() + 10);
		return (
			d.getFullYear() + "-" + pad(d.getMonth() + 1) + "-" + pad(d.getDate())
		);
	}

	class CustomCartDeliveryDate extends HTMLElement {
		constructor() {
			super();
			this.currentValue = "";
			this.hasLeadTime = false;
			this.onLineItemChange = this.onLineItemChange.bind(this);
			this.onInputClick = this.onInputClick.bind(this);
			this.onInputPointerDown = this.onInputPointerDown.bind(this);
			this.onInputChange = this.onInputChange.bind(this);
			this.onInputBlur = this.onInputBlur.bind(this);
			this.onInputKeydown = this.onInputKeydown.bind(this);
			this.onClearClick = this.onClearClick.bind(this);
			this.saveTimer = null;
			this.savePromise = null;
		}

		connectedCallback() {
			this.input = this.querySelector("[data-delivery-date-input]");
			this.field = this.querySelector("[data-field]");
			this.pickerContainer = this.querySelector("[data-picker-container]");
			this.notice = this.querySelector("[data-delivery-date-notice]");
			this.error = this.querySelector("[data-delivery-date-error]");
			this.clearButton = this.querySelector("[data-delivery-date-clear]");
			this.resetInput = this.querySelector("[data-delivery-date-reset]");
			if (!this.input) return;

			// 初期値は YYYY/MM/DD (cart.attributes) を保持変数では YYYY-MM-DD で扱う
			this.currentValue = toDash(this.dataset.initialValue || "");
			this.hasLeadTime = this.dataset.hasLeadTime === "true";
			this.minDateFallback = this.dataset.minDate || computeMinDate();
			this.coarsePointer = isCoarsePointer();

			// 保存値が「今日+10日」より前なら経時で stale になっているとみなして自動クリア
			// （例: 5/22 に 6/1 を選択 → 5/27 に再訪、最短日 6/6 より前 → クリアして「指定なし」に戻す）
			// YYYY-MM-DD の文字列比較で日付の大小判定が可能
			if (this.currentValue && this.currentValue < this.minDate()) {
				this.currentValue = "";
				this.saveAttribute("");
			}

			this.input.addEventListener("click", this.onInputClick);
			this.input.addEventListener("pointerdown", this.onInputPointerDown);
			this.input.addEventListener("change", this.onInputChange);
			this.input.addEventListener("blur", this.onInputBlur);
			this.input.addEventListener("keydown", this.onInputKeydown);
			if (this.clearButton)
				this.clearButton.addEventListener("click", this.onClearClick);
			document.addEventListener("on:line-item:change", this.onLineItemChange);

			// カート空状態で再訪 → 過去の delivery-date 属性が残っていればクリアする
			if (this.dataset.cartEmpty === "true") {
				if (this.currentValue) {
					this.currentValue = "";
					this.saveAttribute("");
				}
				return;
			}

			this.applyLeadTimeState();
		}

		disconnectedCallback() {
			this.flushSave();
			document.removeEventListener(
				"on:line-item:change",
				this.onLineItemChange,
			);
		}

		// サーバー(ショップTZ)と端末ローカルの遅い方を採用する
		// 端末TZが後ろにずれている場合と、ページを長時間開いたままの場合の両方を塞ぐ
		minDate() {
			return laterDate(computeMinDate(), this.minDateFallback);
		}

		setError(message) {
			if (!this.error) return;
			this.error.textContent = message || "";
			this.error.hidden = !message;
		}

		// input は常に type="date"。空値のときだけ「指定なし」オーバーレイを出す
		syncInput() {
			if (!this.input) return;
			this.input.min = this.minDate();
			this.input.value = this.currentValue || "";
			this.setError("");
			if (this.field) this.field.removeAttribute("data-typing");
			this.updatePlaceholder();
		}

		// キーボード入力中だけオーバーレイを退避する
		// (フォーカス基準だとピッカーを閉じた後もフォーカスが残り「指定なし」に戻らない)
		onInputKeydown(event) {
			if (!this.field || !event) return;
			if (event.key === "Tab" || event.key === "Escape") return;
			this.field.setAttribute("data-typing", "true");
		}

		updatePlaceholder() {
			if (!this.field) return;
			if (this.currentValue) this.field.removeAttribute("data-empty");
			else this.field.setAttribute("data-empty", "true");
		}

		// iOS Safari はピッカーを閉じても input にフォーカスが残り、
		// 再タップしてもフォーカス遷移が起きず開かないため、先に外しておく
		onInputPointerDown() {
			if (this.hasLeadTime || !this.coarsePointer) return;
			if (document.activeElement === this.input) this.input.blur();
		}

		onInputClick(event) {
			if (this.hasLeadTime) return;
			// タッチ端末はネイティブのフォーカス動作に任せる (showPicker() と競合して閉じる)
			if (this.coarsePointer) return;
			// 右端はブラウザ標準のカレンダーアイコン領域なのでネイティブ動作に委ねる
			if (event && event.offsetX > this.input.clientWidth - 40) return;
			if (typeof this.input.showPicker !== "function") return;
			try {
				this.input.showPicker();
			} catch (e) {
				/* ユーザー操作起点でない等で失敗した場合はネイティブ動作に委ねる */
			}
		}

		onInputChange() {
			if (this.hasLeadTime) return;
			var value = this.input.value; // YYYY-MM-DD or ''
			if (value === this.currentValue) return;
			// min 属性は入力を防げないため (キーボード直接入力等) 値を検証して差し戻す
			var min = this.minDate();
			if (value && value < min) {
				this.input.value = this.currentValue || "";
				this.setError(
					"最短お届け日 " + toSlash(min) + " 以降の日付をご指定ください。",
				);
				return;
			}
			this.setError("");
			this.currentValue = value || "";
			this.updatePlaceholder();
			// iOS のホイールピッカーは回すたびに change が発火するため保存をまとめる
			clearTimeout(this.saveTimer);
			this.saveTimer = setTimeout(this.flushSave.bind(this), 400);
		}

		onClearClick() {
			if (this.hasLeadTime || !this.currentValue) return;
			this.currentValue = "";
			this.input.value = "";
			this.setError("");
			if (this.field) this.field.removeAttribute("data-typing");
			this.updatePlaceholder();
			// 明示操作なのでデバウンスせず即保存する
			clearTimeout(this.saveTimer);
			this.saveTimer = null;
			this.saveAttribute("");
		}

		onInputBlur() {
			if (this.field) this.field.removeAttribute("data-typing");
			this.updatePlaceholder();
			this.flushSave();
		}

		flushSave() {
			if (!this.saveTimer) return;
			clearTimeout(this.saveTimer);
			this.saveTimer = null;
			this.saveAttribute(this.currentValue);
		}

		// 連続保存でレスポンスが前後し古い値が残らないよう直列化する
		saveAttribute(dashValue) {
			var slash = dashValue ? toSlash(dashValue) : "";
			this.savePromise = (this.savePromise || Promise.resolve())
				.then(function () {
					return fetch("/cart/update.js", {
						method: "POST",
						headers: {
							"Content-Type": "application/json",
							Accept: "application/json",
						},
						body: JSON.stringify({ attributes: { "delivery-date": slash } }),
					});
				})
				.then(function (res) {
					if (!res.ok) throw new Error("HTTP " + res.status);
				})
				.catch(function (err) {
					console.error("[delivery-date] failed to save cart attribute", err);
					document.dispatchEvent(
						new CustomEvent("on:cart:error", {
							bubbles: true,
							detail: { error: err, source: "custom-cart-delivery-date" },
						}),
					);
				});
			return this.savePromise;
		}

		onLineItemChange(event) {
			var cart = event && event.detail && event.detail.cart;
			if (!cart || !Array.isArray(cart.items)) return;
			// カートが空になったら自身を非表示にし、保存済みの配達希望日もクリアする
			if (cart.item_count === 0) {
				this.hidden = true;
				if (this.currentValue) {
					this.currentValue = "";
					this.saveAttribute("");
				}
				return;
			}
			this.hidden = false;
			var hasLeadTime = cartHasLeadTime(cart);
			if (hasLeadTime === this.hasLeadTime) return;
			this.hasLeadTime = hasLeadTime;
			this.applyLeadTimeState();
		}

		applyLeadTimeState() {
			if (this.resetInput) this.resetInput.disabled = !this.hasLeadTime;
			if (this.hasLeadTime) {
				// 選択済みの配達希望日は注文に残さない
				clearTimeout(this.saveTimer);
				this.saveTimer = null;
				if (this.currentValue) {
					this.currentValue = "";
					this.saveAttribute("");
				}
				if (this.pickerContainer) this.pickerContainer.hidden = true;
				if (this.notice) {
					this.notice.hidden = false;
					this.notice.textContent = NOTICE_TEXT;
				}
			} else {
				if (this.pickerContainer) this.pickerContainer.hidden = false;
				if (this.notice) this.notice.hidden = true;
				this.syncInput();
			}
		}
	}

	customElements.define("custom-cart-delivery-date", CustomCartDeliveryDate);
})();
